import React from "react";
import { useTranslation } from "react-i18next";

import { useLocationSelect } from "./hooks";
import Checkbox from "../../FormElement/Checkbox";

import "./styles.scss";

interface ILocationSelectProps {
  locationSelect: ReturnType<typeof useLocationSelect>;
}

export const LocationSelect: React.FC<ILocationSelectProps> = ({
  locationSelect,
}) => {
  const {
    allLocations,
    selectedLocations,
    toggleLocation,
    selectAll,
    clearSelection,
  } = locationSelect;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dataDownloadPage.locationSelect.${key}`);

  return (
    <div className="location-select">
      <div className="location-select-list">
        {allLocations.map((location) => (
          <Checkbox
            key={location.id}
            checked={selectedLocations.some((l) => l.id === location.id)}
            onChange={() => toggleLocation(location)}
            id={location.id.toString()}
            label={location.name}
            className="location-select-checkbox"
          />
        ))}
      </div>
      <div className="location-select-controls">
        <button className="btn btn-blue" onClick={selectAll}>
          {t("select_all")}
        </button>
        <button className="btn btn-border" onClick={clearSelection}>
          {t("clear_selection")}
        </button>
      </div>
    </div>
  );
};
